module.exports = __webpack_public_path__ + "img/bs2.1b0fdfac.png";